import React from "react";
import { EditarDimensionContainer } from "./styles";
import Modal from "../../../../../../shared/util/Modal";
import EditDimensionForm from "./components/editDimensionForm";
import DefaultButton from "../../../../../../shared/util/DefaultButton";
import { DimensionDto } from "../../../../../../shared/dto/DimensionDto";
import ShowDimension from "./components/showDimension";

function EditDimension({
	open,
	setOpen,
	handleDeleteDimensionClick,
	requireDimensionList,
	dimension,
}: Readonly<{
	open: boolean;
	setOpen: React.Dispatch<boolean>;
	handleDeleteDimensionClick: (dimension: DimensionDto) => void;
	requireDimensionList(): Promise<void>;
	dimension: DimensionDto;
}>) {
	const [loading, setLoading] = React.useState(false);
	const [successMessage, setSuccessMessage] = React.useState("");
	const [editMode, setEditMode] = React.useState(false);

	const isEditMode = editMode ? <h2>Editar dimensão</h2> : <h2>Dimensão</h2>;

	React.useEffect(() => {
		if (open) {
			setEditMode(false);
			setSuccessMessage("");
		}
	}, [open]);

	React.useEffect(() => {
		if (!open) {
			setSuccessMessage("");
		}
	}, [open]);

	const title = !successMessage ? isEditMode : <></>;

	return (
		<EditarDimensionContainer>
			<Modal
				open={open}
				setOpen={setOpen}
				containerClassName="adicionar-dimension-modal-container"
				title={title}
				closeButtonCb={!successMessage ? () => setOpen(false) : undefined}
				disableClickOutside={true}
			>
				{!successMessage && !editMode && (
					<ShowDimension
						setOpen={setOpen}
						dimension={dimension}
						setEditMode={setEditMode}
						handleDeleteDimensionClick={handleDeleteDimensionClick}
					/>
				)}

				{!successMessage && editMode && (
					<EditDimensionForm
						dimension={dimension}
						setOpen={setOpen}
						isLoading={loading}
						setLoading={setLoading}
						setSuccessMessage={setSuccessMessage}
						requireDimensionList={requireDimensionList}
						setEditMode={setEditMode}
					/>
				)}

				{successMessage && (
					<div className="edit-dimension-success-step">
						<h2>{successMessage}</h2>
						<div>
							<DefaultButton
								withOutBackground={true}
								width="125px"
								fontSize="1em"
								height="36px"
								params={{
									onClick: () => setOpen(false),
								}}
							>
								Fechar
							</DefaultButton>
						</div>
					</div>
				)}
			</Modal>
		</EditarDimensionContainer>
	);
}

export default EditDimension;
